import { Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-attachFiles',
  templateUrl: './attachFiles.component.html',
  styleUrls: ['./attachFiles.component.scss']
})

export class AttachFilesComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any; 
  transactionID: number=0;
  documentFolderID: number=0;
  documentList:any=[]=[];
  FilesNewList:any=[]=[];
  ShowNoRecordFound:boolean=false;
  placeholderID:number=0;
  azureblobPath:string="";
  placeholderNameForShow:string="";

  constructor(private taskService: SettingService,private dialog: MatDialog,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private loaderService: LoaderService,
    private toastr: ToastrService, 
    public dialogRef: MatDialogRef<AttachFilesComponent>,
    private viewDialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }
  
  ngOnInit(): void {
    this.transactionID = this.data.transactionID;
    this.documentFolderID = this.data.documentFolderID;
    this.placeholderID= this.data.placeholderID;
    this.placeholderNameForShow = this.data.placeholderName;
    this.getAllFolders();
  }

   // get all folders
  getAllFolders() {   
    var reqModel={
     databaseID:Number(this.databaseId),
     organizationID:Number(this.organizationId),
     userID:this.currentUser.UID,
     officeID:this.myOfficeID,
     OfficeIDList:this.OfficeIDList,
     transactionID:Number(this.transactionID)
   }   
    this.loaderService.show();
    this.taskService.GetAllCoreDocumentPlaceholders(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.documentList = response.data;      
          if(this.documentList==null){
            this.documentList=[];
            this.ShowNoRecordFound=true;
          }
          if(this.documentList.length>0){
            this.documentList =this.documentList.filter(x=>x.documentFolderID!=this.documentFolderID)
            // Extract all placeholders where azureblobPath is not null
             const newList = this.documentList
              .flatMap(folder => folder.placeholders || [])
              .filter(ph => ph.azureblobPath != null)
              .map(ph => ({              
                placeholderID: ph.placeholderID,
                placeholderName: ph.placeholderName,
                name: ph.name,
                azureblobPath: ph.azureblobPath,
                fileType: ph.fileType,
                fileSize: ph.fileSize,
                pages: ph.pages,
                fileManagerItemID: ph.fileManagerItemID,
              }));

              this.FilesNewList = newList;   
              if(this.FilesNewList.length>0){
                this.ShowNoRecordFound=false;
              }else{
                this.ShowNoRecordFound=true;
              } 
          }         
         
          this.loaderService.hide();
        } else {
          this.ShowNoRecordFound=true;
          this.loaderService.hide();
        }
      } else {
        this.ShowNoRecordFound=true;
        this.loaderService.hide();
      }
    });
  }

 
  placeholderType:any;
  FileSize:any;

  SelectAITemplate(data:any){
  // this.placeholderID= data.placeholderID;
   this.fileManagerID = data.fileManagerItemID;
   this.PlaceholderName=data.placeholderName;
   //this.azureblobPath=data.azureblobPath;  
  }

  closeAIAutomationTemplate() {
    this.dialog.closeAll();
  }

    formData: FormData;
    fileManagerID:number=0;
    PlaceholderName:string;

   attachFiles() {
    this.formData = new FormData();
    this.formData.append('TransactionID', this.transactionID.toString());
    this.formData.append('DocumentFolderID', this.documentFolderID.toString());
    this.formData.append('FileManagerID', this.fileManagerID.toString());
    this.formData.append('FormID', '0');
    this.formData.append('PlaceholderName', this.PlaceholderName);
    this.formData.append('PlaceholderType', '1');
    this.formData.append('PlaceholderID', this.placeholderID.toString());
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.loaderService.show();    
    this.taskService.AddCoreItemForPlaceholder(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {   
           this.dialogRef.close("Attach");       
           this.toastr.success('File attached successfully selected placeholder.', '', {
            timeOut: 3000,
          });
        } else {
          this.toastr.error('File attach failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('File attach failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
  }
  
}
